// A module entry's own documents, saved one file at a time. Each call answers with the entry's
// whole list afterwards, inside the usual GenericResponse envelope.

import axios from "axios";
import { API_URL } from "const/constants";
import { withErrorMessage } from "views/admin/Clients/documents/clientDocuments.api";

const documentsBase = (moduleType, entryId) =>
  `${API_URL}/modules/${moduleType}/${entryId}/documents`;

/** File an already-uploaded file on the entry under `name`. */
export const addEntryDocument = (moduleType, entryId, { name, url }) =>
  withErrorMessage(
    axios.post(documentsBase(moduleType, entryId), { name, url }).then((r) => r.data?.data ?? [])
  );

/**
 * Remove one document. Rows saved before documents had ids are found by their file, so the URL
 * goes along with the id.
 */
export const removeEntryDocument = (moduleType, entryId, { id, url }) =>
  withErrorMessage(
    axios
      .delete(documentsBase(moduleType, entryId), { params: { id: id || undefined, url } })
      .then((r) => r.data?.data ?? [])
  );
